export default __webpack_public_path__ + "static/media/ic_selo-gptw.b9087bac.svg";